import React, { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { useToast } from "../../context/ToastContext";
import { Panel, Form, Input, Button, Field } from "../common/controls";

const Profile = () => {
  const { user, updateProfile } = useAuth();
  const { showToast } = useToast();
  const [formData, setFormData] = useState({
    firstName: user?.firstName || "",
    lastName: user?.lastName || "",
    bio: user?.bio || "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await updateProfile(formData);
      showToast("Profile updated successfully", "success");
    } catch (error) {
      showToast(error.response?.data?.message || "Update failed", "error");
    }
  };

  return (
    <Panel>
      <h2>Profile</h2>
      <Form onSubmit={handleSubmit}>
        <Field>
          First name
          <Input
            type="text"
            name="firstName"
            value={formData.firstName}
            onChange={handleChange}
          />
        </Field>
        <Field>
          Last name
          <Input
            type="text"
            name="lastName"
            value={formData.lastName}
            onChange={handleChange}
          />
        </Field>
        <Field>
          Bio
          <Input
            type="text"
            name="bio"
            value={formData.bio}
            onChange={handleChange}
          />
        </Field>
        <Button type="submit">Update Profile</Button>
      </Form>
    </Panel>
  );
};

export default Profile;
